<template>
  <NavBar></NavBar>
  <HeroSection></HeroSection>
  <TermsConditions></TermsConditions>
  <FooterBar></FooterBar>
</template>

<script>
import NavBar from './components/NavBar.vue'
import HeroSection from './components/HeroSection.vue'
import TermsConditions from './components/TermsConditions.vue'
import FooterBar from './components/FooterBar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    HeroSection,
    TermsConditions,
    FooterBar
  }
}
</script>

<style>
body {
  margin: 0;
}


@font-face {
  font-family: JETSansExtraBlack;
  src: url('@/assets/fonts/JETSansVF2-Merged.woff2') format("woff2"),
  url('@/assets/fonts/JETSansVF2-Merged.woff') format("woff");
  font-weight: 999;
}
</style>
